// This file was auto-generated by 'typesafe-i18n'. Any manual changes will be overwritten.
/* eslint-disable */

import { initFormatters } from './formatters'
import type { Locales, Translations } from './i18n-types'
import { loadedFormatters, loadedLocales, locales } from './i18n-util'

const localeTranslationLoaders = {
	'ar-SA': () => import('./ar-SA'),
	'ca-ES': () => import('./ca-ES'),
	'de-DE': () => import('./de-DE'),
	'dsb-DE': () => import('./dsb-DE'),
	'en-US': () => import('./en-US'),
	'es-ES': () => import('./es-ES'),
	'fr-FR': () => import('./fr-FR'),
	'hsb-DE': () => import('./hsb-DE'),
	'it-IT': () => import('./it-IT'),
	'ja-JP': () => import('./ja-JP'),
	'ko-KR': () => import('./ko-KR'),
	'nl-NL': () => import('./nl-NL'),
	'pt-BR': () => import('./pt-BR'),
	'zh-CN': () => import('./zh-CN'),
	'zh-TW': () => import('./zh-TW'),
}

const updateDictionary = (locale: Locales, dictionary: Partial<Translations>): Translations =>
	loadedLocales[locale] = { ...loadedLocales[locale], ...dictionary }

export const importLocaleAsync = async (locale: Locales): Promise<Translations> =>
	(await localeTranslationLoaders[locale]()).default as unknown as Translations

export const loadLocaleAsync = async (locale: Locales): Promise<void> => {
	updateDictionary(locale, await importLocaleAsync(locale))
	loadFormatters(locale)
}

export const loadAllLocalesAsync = (): Promise<void[]> => Promise.all(locales.map(loadLocaleAsync))

export const loadFormatters = (locale: Locales): void =>
	void (loadedFormatters[locale] = initFormatters(locale))
